import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FeatherIcon, LockIcon, UserIcon, EyeIcon, EyeOffIcon, ArrowLeftIcon } from 'lucide-react';
export function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  // Check if user is already logged in
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) {
      navigate('/admin');
    }
  }, [navigate]);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      // Hardcoded authentication for demo purposes
      // In a real app, you would validate against a secure backend
      if (username === 'admin' && password === 'admin123') {
        // Set auth token (simplified for demo)
        localStorage.setItem('authToken', '1');
        localStorage.setItem('userName', 'Kibaki Muthamia');
        navigate('/admin');
      } else {
        throw new Error('Invalid username or password');
      }
    } catch (err: any) {
      setError(err.message || 'Authentication failed');
    } finally {
      setLoading(false);
    }
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col justify-center" data-id="element-959">
      <div className="max-w-md w-full mx-auto" data-id="element-960">
        <div className="text-center mb-8" data-id="element-961">
          <div className="flex justify-center mb-4" data-id="element-962">
            <FeatherIcon size={40} className="text-amber-600" data-id="element-963" />
          </div>
          <h2 className="text-3xl font-bold" data-id="element-964">Admin Login</h2>
          <p className="text-gray-600 mt-2" data-id="element-965">
            Sign in to manage your blog content
          </p>
        </div>
        <div className="bg-white rounded-lg shadow-md p-8" data-id="element-966">
          {error && <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-md text-sm" data-id="element-967">
              {error}
            </div>}
          <form onSubmit={handleSubmit} data-id="element-968">
            <div className="mb-6" data-id="element-969">
              <label htmlFor="username" className="block text-gray-700 font-medium mb-2" data-id="element-970">
                Username
              </label>
              <div className="relative" data-id="element-971">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-972">
                  <UserIcon size={18} className="text-gray-400" data-id="element-973" />
                </div>
                <input id="username" type="text" value={username} onChange={e => setUsername(e.target.value)} className="pl-10 w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" placeholder="Enter your username" required data-id="element-974" />
              </div>
              <p className="mt-1 text-xs text-gray-500" data-id="element-975">Demo username: admin</p>
            </div>
            <div className="mb-6" data-id="element-976">
              <label htmlFor="password" className="block text-gray-700 font-medium mb-2" data-id="element-977">
                Password
              </label>
              <div className="relative" data-id="element-978">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-979">
                  <LockIcon size={18} className="text-gray-400" data-id="element-980" />
                </div>
                <input id="password" type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} className="pl-10 w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" placeholder="Enter your password" required data-id="element-981" />
                <div className="absolute inset-y-0 right-0 pr-3 flex items-center" data-id="element-982">
                  <button type="button" onClick={() => setShowPassword(!showPassword)} className="text-gray-400 hover:text-gray-600" data-id="element-983">
                    {showPassword ? <EyeOffIcon size={18} data-id="element-984" /> : <EyeIcon size={18} data-id="element-985" />}
                  </button>
                </div>
              </div>
              <p className="mt-1 text-xs text-gray-500" data-id="element-986">
                Demo password: admin123
              </p>
            </div>
            <button type="submit" disabled={loading} className="w-full bg-amber-600 text-white py-3 px-4 rounded-md hover:bg-amber-700 transition-colors font-medium flex justify-center items-center" data-id="element-987">
              {loading ? <span className="w-5 h-5 border-t-2 border-white border-solid rounded-full animate-spin mr-2" data-id="element-988"></span> : null}
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>
        <div className="text-center mt-6" data-id="element-989">
          <Link to="/" className="text-amber-600 hover:underline flex items-center justify-center" data-id="element-990">
            <ArrowLeftIcon size={16} className="mr-2" data-id="element-991" />
            Return to Website
          </Link>
        </div>
      </div>
    </div>;
}